import axios from 'axios'
import Vue from 'vue'
import router from '../router'
const service = axios.create({
    // url = base url + request url
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 6000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
      if (config.url.includes('wxshare/api')){
        config.headers['Content-Type'] = 'multipart/form-data'
        return config
      }else {
        const token = localStorage.getItem('wa-token')
        config.headers['Content-Type'] = 'multipart/form-data'
        config.headers['wa-token'] = token
        return config
      }
    },
    error => {
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    (response) => {
        const res = response.data
        if (res.code === undefined){
          return res
        }else if (res.code === 99) {
          localStorage.clear()
          router.replace('/login')
          return
        } else if (res.code !== 0){
          return Promise.reject(new Error(res.msg || 'Error'))
        }else {
          return res
        }
    },
    err => {
      return Promise.reject(err)
    }
)
Vue.$request = service
export default service
